/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'paneCustomTermsId';
const QS_TYPE: QueryStateSchema['type'] = 'customTerms';

export const useOpenCustomTermsPane = (): ((args: { customTermsId: string }) => void) => {
  const [customTermsIdDeprecated, setCustomTermsId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (customTermsIdDeprecated) {
      setCustomTermsId(null);
      setState(backwardsCompatabilityFactory({ id: customTermsIdDeprecated, type: QS_TYPE }));
    }
  }, [customTermsIdDeprecated]);

  return ({ customTermsId }) => {
    setState(prevState => [...(prevState || []), {
      id: customTermsId,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};
